var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
export default (function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? '#000000' : _b, rest = __rest(_a, ["fill"]);
    return (_jsx("svg", __assign({ width: "16", height: "10", viewBox: "0 0 16 10", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, rest, { children: _jsx("path", { d: "M0.440786 6.68188L7.01229 0.396378C7.2885 0.131877 7.64454 0.000199541 8 0.000199572C8.35546 0.000199603 8.7115 0.131877 8.98772 0.396378L15.5592 6.68188C16.129 7.22759 16.1491 8.13159 15.6039 8.70188C15.0581 9.27327 14.1541 9.29113 13.5838 8.74652L8 3.4052L2.41625 8.74652C1.84593 9.29227 0.941893 9.27216 0.396143 8.70188C-0.149073 8.13159 -0.128965 7.22759 0.440786 6.68188Z", fill: fill }) })));
});
